// react-select filterOption for country dropdowns: match the typed text from the start of any word,
// so "In" finds India/Indonesia (not Argentina) and "Korea" still finds "Republic of Korea".
// Accents are ignored ("Cote" finds "Côte d'Ivoire"), like react-select's default filter.
const escapeRegExp = (text) => text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
const stripAccents = (text) => text.normalize("NFD").replace(/[̀-ͯ]/g, "");

export const filterCountryOption = (option, input) => {
  const typed = stripAccents(String(input || "").trim());
  if (!typed) return true;
  const label = stripAccents(String(option.label || ""));
  return new RegExp(`(^|[\\s(\\-'’/])${escapeRegExp(typed)}`, "i").test(label);
};
